import { FILTER_TYPES } from 'components/FilterPod';
import jMoment from 'moment-jalaali';

export const STATUS_BRANCH_OPTIONS = [
  {
    value: true,
    label: 'فعال',
  },

  {
    value: false,
    label: 'غیرفعال',
  },
];

const filters = () => [
  {
    title: 'محدوده تاریخ پرداخت',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    id: {
      start: null,
      end: null,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {
        minDate: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(731, 'days'),
        maxDate: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
      end: {
        minDate: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(731, 'days'),
        maxDate: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
    },
    disableDelete: false,
  },
  {
    title: 'شناسه فاکتور',
    label: 'شناسه فاکتور',
    keyName: 'subjectInvoiceId',
    query: 'subjectInvoiceId',
    id: 2,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
];

export default filters;
